import { Component } from '@angular/core';
import { PlaceholderPageComponent } from '../../../pages/placeholder/placeholder-page.component';

@Component({
  selector: 'app-event-calculator',
  standalone: true,
  imports: [PlaceholderPageComponent],
  template: `
    <app-placeholder-page 
      title="calculatorList.event.title" 
      icon="construction"
      >
    </app-placeholder-page>
  `
})
export class EventCalculatorComponent {}